// extracted by mini-css-extract-plugin
module.exports = {"root":"BrandLinks_root__RP85I","item":"BrandLinks_item__IurT_"};